import { useState } from "react";
import { Checkbox, Divider, Text } from "@ds/react";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import { ReactComponent as DownloadIcon } from "assets/icons/download.svg";
import * as S from "./DadosCondicoesGerais.style";
import { getEnvVar } from "utils/environment";
import ActionFooter from "components/ActionFooter/ActionFooter";

const DadosCondicoesGerais = ({ loading }) => {
  const [checked, setChecked] = useState(false);

  return (
    <section>
      <Section>
        <ResponsiveCard maxContent title="Condições gerais">
          <Text variant="body-02-sm">
            E por último, é importante que você leia as condições gerais e
            aceite as regras
          </Text>
          <S.Download
            onClick={() => window.open(getEnvVar("CONDICOES_GERAIS"), "_blank")}
          >
            <DownloadIcon />
            <Text variant="link-02-sm">
              Baixar condições gerais de capitalização
            </Text>
          </S.Download>
          <Divider />
          <Checkbox
            className="checkbox"
            value={checked}
            onChange={setChecked}
            label={`Li e estou ciente das regras`}
          />
          <ActionFooter
            primaryLabel="Ir para o pagamento"
            disabled={!checked}
            loading={loading}
            goBackTo="/unico/resumo"
          />
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default DadosCondicoesGerais;
